import './organization.modal.component.scss';
import template from './organization.modal.component.html';

/* @ngInject */
function OrganizationComponent(
  $uibModalInstance,
  growl,
  entity,
  groups,
) {
  const vm = this;

  vm.$onInit = $onInit;
  vm.dismiss = $uibModalInstance.dismiss;
  vm.save = save;

  vm.editing = Boolean(entity);
  vm.title = vm.editing ? `Editing ${entity.name}` : 'New organization';


  function $onInit() {
    vm.entity = _.cloneDeep(entity ?? {});
    vm.groups = groups;

    _.defaults(vm.entity, { state: 'ACTIVE' });
    vm.selectedGroup = vm.entity.rootGroup ?? _.head(vm.groups);
  }

  function save() {
    const problems = getFormProblems();
    if (!_.isEmpty(problems)) {
      return void showUserHelp(problems);
    }

    const blueprint = {
      ...vm.entity,
      parentGroupId: vm.selectedGroup.id
    };
    $uibModalInstance.close(blueprint);
  }


  function showUserHelp(problems) {
    _.keys(problems).forEach(message => growl.warning(message, { title: 'Problem in form:' }));
  }

  function getFormProblems() {
    const problems = _.pickBy({
      'Never a problem, just a placeholder': vm.entity === 'banana',
    }, Boolean);
    return problems;
  }
}

export default {
  template,
  controller: OrganizationComponent,
  controllerAs: '$modal',
  bindings: {
    entity: '<?',
    groups: '<',
  }
};
